'use client';

import { OnboardingWrapper } from '@/components/onboarding/onboarding-wrapper';
import { SidebarProvider } from '@ui/components/ui/sidebar';
import { ReactNode } from 'react';
import { AppProvider } from './app-context';
import { UserProvider } from './user-context';
import { getUser } from '@/dal/users/read';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

type UserWithoutMeta = NonNullable<Awaited<ReturnType<typeof getUser>>>;

export interface ProvidersProps {
  user: UserWithoutMeta;
  creditsRemaining: number;
}

// Create a client outside the component to ensure it persists
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60000, // 1 minute
    },
  },
});

export default function Providers({ user, creditsRemaining, children }: ProvidersProps & { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider initialUser={user} initialCredits={creditsRemaining}>
        <AppProvider>
          <OnboardingWrapper>
            <SidebarProvider>{children}</SidebarProvider>
          </OnboardingWrapper>
        </AppProvider>
      </UserProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
